import sizes from './sizes';

const FONT_FAMILY = {
    inter: 'Inter',
    interTight: 'InterTight'
};

const FONT_WEIGHT = {
    regular: '400',
    medium: '500',
    semiBold: '600',
    bold: '700'
};
export default Object.freeze({
    /**
     * Display (header) styles are used sparingly,
     * primarily as page titles, section titles, subsection headers, and occasional inline titles.
     */
    display: {
        xl: {
            regular: {
                fontFamily: FONT_FAMILY.interTight,
                fontSize: sizes.font['5xl'], // 48px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.regular,
                lineHeight: `${sizes.font['5xl'] + sizes.fixedSpacing.lg}px` // 60px
            },
            medium: {
                fontFamily: FONT_FAMILY.interTight,
                fontSize: sizes.font['5xl'], // 48px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.medium,
                lineHeight: `${sizes.font['5xl'] + sizes.fixedSpacing.lg}px` // 60px
            },
            semiBold: {
                fontFamily: FONT_FAMILY.interTight,
                fontSize: sizes.font['5xl'], // 48px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.semiBold,
                lineHeight: `${sizes.font['5xl'] + sizes.fixedSpacing.lg}px` // 60px
            },
            bold: {
                fontFamily: FONT_FAMILY.interTight,
                fontSize: sizes.font['5xl'], // 48px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.bold,
                lineHeight: `${sizes.font['5xl'] + sizes.fixedSpacing.lg}px` // 60px
            }
        },

        lg: {
            regular: {
                fontFamily: FONT_FAMILY.interTight,
                fontSize: sizes.font['4xl'], // 36px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.regular,
                lineHeight: `${sizes.font['4xl'] + sizes.fixedSpacing.md}px` // 44px
            },
            medium: {
                fontFamily: FONT_FAMILY.interTight,
                fontSize: sizes.font['4xl'], // 36px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.medium,
                lineHeight: `${sizes.font['4xl'] + sizes.fixedSpacing.md}px` // 44px
            },
            semiBold: {
                fontFamily: FONT_FAMILY.interTight,
                fontSize: sizes.font['4xl'], // 36px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.semiBold,
                lineHeight: `${sizes.font['4xl'] + sizes.fixedSpacing.md}px` // 44px
            },
            bold: {
                fontFamily: FONT_FAMILY.interTight,
                fontSize: sizes.font['4xl'], // 36px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.bold,
                lineHeight: `${sizes.font['4xl'] + sizes.fixedSpacing.md}px` // 44px
            }
        },
        md: {
            regular: {
                fontFamily: FONT_FAMILY.interTight,
                fontSize: sizes.font['3xl'], // 30px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.regular,
                lineHeight: `${sizes.font['3xl'] + sizes.fixedSpacing.md}px` // 38px
            },
            medium: {
                fontFamily: FONT_FAMILY.interTight,
                fontSize: sizes.font['3xl'], // 30px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.medium,
                lineHeight: `${sizes.font['3xl'] + sizes.fixedSpacing.md}px` // 38px
            },
            semiBold: {
                fontFamily: FONT_FAMILY.interTight,
                fontSize: sizes.font['3xl'], // 30px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.semiBold,
                lineHeight: `${sizes.font['3xl'] + sizes.fixedSpacing.md}px` // 38px
            },
            bold: {
                fontFamily: FONT_FAMILY.interTight,
                fontSize: sizes.font['3xl'], // 30px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.bold,
                lineHeight: `${sizes.font['3xl'] + sizes.fixedSpacing.md}px` // 38px
            }
        },
        sm: {
            regular: {
                fontFamily: FONT_FAMILY.interTight,
                fontSize: sizes.font['2xl'], // 24px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.regular,
                lineHeight: `${sizes.font['2xl'] + sizes.fixedSpacing.md}px` // 32px
            },
            medium: {
                fontFamily: FONT_FAMILY.interTight,
                fontSize: sizes.font['2xl'], // 24px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.medium,
                lineHeight: `${sizes.font['2xl'] + sizes.fixedSpacing.md}px` // 32px
            },
            semiBold: {
                fontFamily: FONT_FAMILY.interTight,
                fontSize: sizes.font['2xl'], // 24px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.semiBold,
                lineHeight: `${sizes.font['2xl'] + sizes.fixedSpacing.md}px` // 32px
            },
            bold: {
                fontFamily: FONT_FAMILY.interTight,
                fontSize: sizes.font['2xl'], // 24px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.bold,
                lineHeight: `${sizes.font['2xl'] + sizes.fixedSpacing.md}px` // 32px
            }
        },
        xs: {
            regular: {
                fontFamily: FONT_FAMILY.interTight,
                fontSize: sizes.font.xl, // 22px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.regular,
                lineHeight: `${sizes.font.xl + sizes.fixedSpacing.md}px` // 32px
            },
            medium: {
                fontFamily: FONT_FAMILY.interTight,
                fontSize: sizes.font.xl, // 22px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.medium,
                lineHeight: `${sizes.font.xl + sizes.fixedSpacing.md}px` // 32px
            },
            semiBold: {
                fontFamily: FONT_FAMILY.interTight,
                fontSize: sizes.font.xl, // 22px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.semiBold,
                lineHeight: `${sizes.font.xl + sizes.fixedSpacing.md}px` // 32px
            },
            bold: {
                fontFamily: FONT_FAMILY.interTight,
                fontSize: sizes.font.xl, // 22px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.bold,
                lineHeight: `${sizes.font.xl + sizes.fixedSpacing.md}px` // 32px
            }
        }
    },
    /**
     * Text (paragraph) styles are used more often in the UI.
     * Utilize text styles for paragraphs, support text, form field labels and inputs, button labels, and metadata, etc.
     */
    text: {
        xl: {
            regular: {
                fontFamily: FONT_FAMILY.inter,
                fontSize: sizes.font.xl, // 22px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.regular,
                lineHeight: `${sizes.font.xl + sizes.fixedSpacing.lg}px` // 32px
            },
            medium: {
                fontFamily: FONT_FAMILY.inter,
                fontSize: sizes.font.xl, // 22px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.medium,
                lineHeight: `${sizes.font.xl + sizes.fixedSpacing.lg}px` // 32px
            },
            semiBold: {
                fontFamily: FONT_FAMILY.inter,
                fontSize: sizes.font.xl, // 22px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.semiBold,
                lineHeight: `${sizes.font.xl + sizes.fixedSpacing.lg}px` // 32px
            },
            bold: {
                fontFamily: FONT_FAMILY.inter,
                fontSize: sizes.font.xl, // 22px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.bold,
                lineHeight: `${sizes.font.xl + sizes.fixedSpacing.lg}px` // 32px
            }
        },
        lg: {
            regular: {
                fontFamily: FONT_FAMILY.inter,
                fontSize: sizes.font.lg, // 18px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.regular,
                lineHeight: `${sizes.font.lg + sizes.fixedSpacing.lg}px` // 28px
            },
            medium: {
                fontFamily: FONT_FAMILY.inter,
                fontSize: sizes.font.lg, // 18px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.medium,
                lineHeight: `${sizes.font.lg + sizes.fixedSpacing.lg}px` // 28px
            },
            semiBold: {
                fontFamily: FONT_FAMILY.inter,
                fontSize: sizes.font.lg, // 18px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.semiBold,
                lineHeight: `${sizes.font.lg + sizes.fixedSpacing.lg}px` // 28px
            },
            bold: {
                fontFamily: FONT_FAMILY.inter,
                fontSize: sizes.font.lg, // 18px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.bold,
                lineHeight: `${sizes.font.lg + sizes.fixedSpacing.lg}px` // 28px
            }
        },
        md: {
            regular: {
                fontFamily: FONT_FAMILY.inter,
                fontSize: sizes.font.md, // 16px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.regular,
                lineHeight: `${sizes.font.md + sizes.fixedSpacing.md}px` // 24px
            },
            medium: {
                fontFamily: FONT_FAMILY.inter,
                fontSize: sizes.font.md, // 16px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.medium,
                lineHeight: `${sizes.font.md + sizes.fixedSpacing.md}px` // 24px
            },
            semiBold: {
                fontFamily: FONT_FAMILY.inter,
                fontSize: sizes.font.md, // 16px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.semiBold,
                lineHeight: `${sizes.font.md + sizes.fixedSpacing.md}px` // 24px
            },
            bold: {
                fontFamily: FONT_FAMILY.inter,
                fontSize: sizes.font.md, // 16px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.bold,
                lineHeight: `${sizes.font.md + sizes.fixedSpacing.md}px` // 24px
            }
        },
        sm: {
            regular: {
                fontFamily: FONT_FAMILY.inter,
                fontSize: sizes.font.sm, // 14px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.regular,
                lineHeight: `${sizes.font.sm + sizes.fixedSpacing.sm}px` // 20px
            },
            medium: {
                fontFamily: FONT_FAMILY.inter,
                fontSize: sizes.font.sm, // 14px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.medium,
                lineHeight: `${sizes.font.sm + sizes.fixedSpacing.sm}px` // 20px
            },
            semiBold: {
                fontFamily: FONT_FAMILY.inter,
                fontSize: sizes.font.sm, // 14px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.semiBold,
                lineHeight: `${sizes.font.sm + sizes.fixedSpacing.sm}px` // 20px
            },
            bold: {
                fontFamily: FONT_FAMILY.inter,
                fontSize: sizes.font.sm, // 14px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.bold,
                lineHeight: `${sizes.font.sm + sizes.fixedSpacing.sm}px` // 20px
            }
        },
        xs: {
            regular: {
                fontFamily: FONT_FAMILY.inter,
                fontSize: sizes.font.xs, // 12px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.regular,
                lineHeight: `${sizes.font.xs + sizes.fixedSpacing.sm}px` // 18px
            },
            medium: {
                fontFamily: FONT_FAMILY.inter,
                fontSize: sizes.font.xs, // 12px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.medium,
                lineHeight: `${sizes.font.xs + sizes.fixedSpacing.sm}px` // 18px
            },
            semiBold: {
                fontFamily: FONT_FAMILY.inter,
                fontSize: sizes.font.xs, // 12px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.semiBold,
                lineHeight: `${sizes.font.xs + sizes.fixedSpacing.sm}px` // 18px
            },
            bold: {
                fontFamily: FONT_FAMILY.inter,
                fontSize: sizes.font.xs, // 12px
                fontStyle: 'normal',
                fontWeight: FONT_WEIGHT.bold,
                lineHeight: `${sizes.font.xs + sizes.fixedSpacing.sm}px` // 18px
            }
        }
    }
});
